import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist({
  key: 'admin-persist', // this key is using to store data in local storage
  storage: localStorage, // configurate which storage will be used to store the data
})

export { persistAtom }
